<template>
  <div class="notice-info home-bg">
    <div class="main-content">
      <div class="menu main-second-bg" :style="{ height: menuBoxHeight }" ref="menuBox">
        <div class="menu-tit medium f-1-cl">{{ $t("message.noticeInfo") }}</div>
        <div class="search-notice-box a-2-bd" v-if="openSearch">
          <div class="iconfont-cont">
            <svg aria-hidden="true" class="icon icon-14">
              <use xlink:href="#icon-a_12"></use>
            </svg>
          </div>
          <input
            class="search-notice-input f-1-cl"
            type="text"
            :placeholder="$t('message.search')"
            @input="setNoticeSearchVal"
            v-model="noticeSearchVal"
          />
          <span class="clones b-2-cl" v-show="noticeSearchVal" @click="clearSearchVal">x</span>
        </div>

        <ul ref="menuBar" class="f-2-cl">
          <li
            v-for="(item, index) in sideList"
            :key="index"
            :class="{ 'main-cl gray-10-bg': contentId === item.id }"
            @click="writing(item.id)"
            class="menu-item"
            :title="item.title"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="empty-box" v-if="!sideList.length && searchLoaded">
          <div class="home-nodata">
            <svg class="icon icon-50" aria-hidden="true">
              <use xlink:href="#icon-g_2"></use>
            </svg>
            <p class="notice-empty-text">
              <!-- 暂无数据 -->
              {{ $t("common.notData") }}
            </p>
          </div>
        </div>
        <c-pagination
          v-if="pagination.count / pagination.pageSize > 1"
          :total="pagination.count"
          :current-page="pagination.page"
          :display="pagination.pageSize"
          @pagechange="pagechange"
          class="no-paddleft"
        >
        </c-pagination>
      </div>
      <div class="content-box main-second-bg">
        <div class="content-text" :style="{ 'min-height': contentMinHeight }">
          <h1 class="content-title main-cl">{{ notieContent.title }}</h1>
          <p class="time main-cl">{{ notieContent.ctime }}</p>
          <div class="ql-editor-new gray-cl" v-html="notieContent.content"></div>
          <transition name="fade">
            <div v-show="isshowLoading" class="loading">
              <c-loading size="50" />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'BlockChain-ui-privatization/static/css/quill.core.styl';
import 'BlockChain-ui-privatization/static/css/quill.snow.styl';
import 'BlockChain-ui-privatization/static/css/quill.bubble.styl';
import { myStorage, formatTime } from '@/utils';

export default {
  name: 'noticeInfo',
  data() {
    return {
      contentId: parseFloat(myStorage.get('ntId')) || null,
      sideList: [],
      notieContent: {},
      menuBarHeight: null,
      isshowLoading: true,
      pagination: {
        // 翻页数据
        count: 0, // 总数量
        pageSize: 9, // 每页显示条数
        page: 1, // 当前页数
      },
      noticeSearchVal: '',
      cacheData: {
        sideList: [],
        pagination: [],
      },
      timer: null,
      searchLoaded: false,
      openSearch: false,
    };
  },
  computed: {
    menuBoxHeight() {
      if (this.menuBarHeight > 860) {
        return '860px';
      }
      return 'auto';
    },
    contentMinHeight() {
      if (this.menuBarHeight > 860) {
        return '760px';
      }
      return '';
    },
  },
  filters: {
    cutTextLength(value) {
      return value.slice(0, 20);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.menuBarHeight = this.$refs.menuBar.offsetHeight;
      if (this.$route.params.ntId) {
        this.contentId = parseFloat(this.$route.params.ntId);
      }
      // 获取列表书数据
      this.getListData();
      // 获取 内容
      this.getContentData();
    },
    clearSearchVal() {
      this.noticeSearchVal = '';
      this.setCacheToData();
    },
    setDataToCache() {
      const { sideList, pagination } = this;
      this.cacheData = {
        cache: true,
        sideList,
        pagination,
      };

      this.sideList = [];
      this.pagination = {
        count: 0,
        pageSize: 10,
        page: 1,
      };
    },
    setCacheToData() {
      const { sideList, pagination } = this.cacheData;
      this.sideList = sideList;
      this.pagination = pagination;
      this.cacheData = {
        sideList: [],
        pagination: [],
        cache: false,
      };
    },
    postValToSearch() {
      this.searchLoaded = false;

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        if (this.noticeSearchVal !== '') {
          this.isshowLoading = true;
          this.searchNoticeToKey(this.noticeSearchVal);
        }
      }, 300);
    },
    searchNoticeToKey() {
      // this.searchLoaded = true;
      //   this.isshowLoading = false;
      //   if (data.code === '0' && this.noticeSearchVal !== '') {
      //     this.sideList = [];
      //   }
      if (this.noticeSearchVal !== '') {
        this.getListData(true);
      }
    },
    setNoticeSearchVal() {
      if (this.noticeSearchVal) {
        if (!this.cacheData.cache) {
          this.setDataToCache();
        }
        this.postValToSearch();
      }
      if (this.noticeSearchVal === '' && this.cacheData.cache) {
        this.setCacheToData();
      }
    },
    // 翻页事件
    pagechange(num) {
      const isSearch = this.noticeSearchVal !== '';
      this.pagination.page = num;
      this.getListData(isSearch);
    },
    // 获取列表书数据
    getListData(isSearch = false) {
      const keyword = isSearch ? this.noticeSearchVal : '';
      this.getData({
        url: this.$store.state.url.notice.notice_list,
        params: {
          keyword,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
        },
        callback: (data) => {
          this.isshowLoading = false;
          this.searchLoaded = true;
          this.openSearch = data.data.openSearch;

          // 如果路由没有参数 默认显示第一条数据
          if (!isSearch || (isSearch && this.noticeSearchVal !== '')) {
            this.sideList = data.data.noticeInfoList;
            this.pagination.count = data.data.count;
          }

          if (!parseFloat(this.$route.params.ntId)) {
            this.writing(data.data.noticeInfoList[0].id);
            this.$router.push(`/noticeInfo/${data.data.noticeInfoList[0].id}`);
          }
        },
      });
    },
    // 获取 内容
    getContentData() {
      this.getData({
        url: this.$store.state.url.notice.notice_info,
        params: {
          id: this.contentId,
        },
        callback: (data) => {
          this.notieContent = data.data.noticeInfo;
          this.notieContent.ctime = formatTime(data.data.noticeInfo.ctime);
        },
      });
    },
    writing(i) {
      if (i !== this.contentId) {
        myStorage.set('ntId', i);
        this.contentId = i;
        // this.$router.push({ path: 'noticeInfo', params: { ntId: i } });
        this.$router.push(`${i}`);
        this.getContentData();
      }
    },
    getData(datas) {
      this.isshowLoading = true;
      const { url, params, callback } = datas;
      this.axios({
        url,
        params,
        method: 'post',
      }).then((data) => {
        this.isshowLoading = false;
        if (data.code === '0') {
          callback(data);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/global.scss";
.notice-info {
  position: relative;
  margin-bottom: 30px;

  img {
    max-width: 90%;
    max-height: 90%;
  }
  .no-paddleft {
    padding-left: 0;
  }
  .empty-box {
    margin: 40px auto 0 auto;
    text-align: center;
    .notice-empty-text {
      margin-top: 10px;
    }
  }
  .main-content {
    width: 1200px;
    margin: 40px auto 0;
    display: flex;
    gap: 24px;
  }
  .menu {
    width: 310px;
    // padding: 24px;
    border-radius: 6px;

    .menu-tit {
      font-size: 16px;
      line-height: 56px;
      padding-left: 20px;
    }
    .menu-item {
      font-size: 14px;
      box-sizing: border-box;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -moz-box;
      -moz-line-clamp: 2;
      overflow-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      overflow: hidden;
      line-height: 24px;
      padding: 16px 20px;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 4px;

      &:hover {
        background-color: $gray-10;
      }
    }
    .pagination {
      background: none !important;
      border: none !important;
    }
    .pagination-bar {
      border: none !important;
      line-height: 50px;
      .num {
        margin: 0;
      }
      .pagination-btn {
        height: 30px;
        width: 30px;
        line-height: 30px;
      }
    }
  }

  .content-box {
    width: 966px;
    border-radius: 6px;

    .content-text {
      min-height: 680px;
      padding: 32px;
      position: relative;
      border-radius: 2px;
      .content-title {
        font-size: 22px;
        font-weight: normal;
        line-height: 30px;
      }
      .time {
        // width: 100px;
        margin-top: 20px;
        font-size: 12px;
        line-height: 16px;
      }
      .main-text {
        margin-top: 30px;
        line-height: 24px;
        font-size: 14px;
        p {
          word-break: break-all;
        }
      }
    }
  }
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 999;
    margin: -25px 0 0 -25px;
  }
  .search-notice-box {
    border-width: 1px;
    border-style: solid;
    height: 28px;
    line-height: 26px;
    margin: 13px 20px;
    .clones {
      font-size: 13px;
      padding: 0 4px;
      vertical-align: middle;
      cursor: pointer;
    }
    .iconfont-cont {
      text-align: center;
      display: inline-block;
      width: 30px;
      vertical-align: middle;
    }
    .search-notice-input {
      width: 140px;
      vertical-align: middle;
    }
  }
  .ql-editor-new {
    padding: 32px 0;
    font-size: 14px;
    line-height: 24px;
  }
}
.notice-info .content-text .mmd-loading-circle-right,
.notice-info .content-text .mmd-loading-circle-left {
  border-color: #1baaec;
}
.notice-info .fade-enter-active,
.notice-info .fade-leave-active {
  transition: opacity 0.8s;
}
.notice-info .fade-enter,
.notice-info .fade-leave-to {
  opacity: 0;
}
</style>
